import { Box, Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { Link } from "react-router-dom";

import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { TransactionFilter } from "../components/transaction_filter";
import { TransactionList } from "../components/transaction_list";

export const TransactionListPage: React.FC = () => {
  return (
    <div>
      <Box py={3}>
        <Box pr={2} component="span">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            to={`${Routing.generateCreateRoute(ROUTES.transaction)}/buy`}
            component={Link}
          >
            Alış
          </Button>
        </Box>

        <Box pr={2} component="span">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            to={`${Routing.generateCreateRoute(ROUTES.transaction)}/sell`}
            component={Link}
          >
            Satış
          </Button>
        </Box>

        <Box pr={2} component="span">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            to={`${Routing.generateCreateRoute(ROUTES.transaction)}`}
            component={Link}
          >
            Digər
          </Button>
        </Box>
      </Box>

      <TransactionFilter />

      <Box mb={2}></Box>

      <TransactionList />
    </div>
  );
};
